export default "__VITE_ASSET__Bq7UJ2Fl__"